import React, { Component } from 'react';

import TubeStand from './img/TubeStand.svg';

class Graphics extends Component {

  render () {
    return (
      <div>
        <img width="310px" src={TubeStand} alt={'Empty Tube Stand'} />
      </div>
    );
  }

}

export default Graphics;
